module.exports = __webpack_public_path__ + "img/iconExcel.5d96517a.svg";